import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const content: SxStyle = {
  background: (p) => p.palette.common.white,
  py: 1.5,
  px: 2,
};
